import type { $Fetch } from 'ofetch';
import type { PeriodoLetivoGateway, ListPeriodosParams } from '@/application/port/out/PeriodoLetivoGateway';
import type { PeriodoLetivo, UpsertPeriodoLetivoCommand } from '@/domain/model/PeriodoLetivo';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/periodos-letivos';

/** HTTP gateway de Período Letivo. Authority BE: `enrollment:periodo_letivo:read|manage`. */
export class HttpPeriodoLetivoGateway implements PeriodoLetivoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListPeriodosParams): Promise<Page<PeriodoLetivo>> {
    const res = await this.client<ApiResponse<Page<PeriodoLetivo>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertPeriodoLetivoCommand): Promise<PeriodoLetivo> {
    const res = await this.client<ApiResponse<PeriodoLetivo>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertPeriodoLetivoCommand): Promise<PeriodoLetivo> {
    const res = await this.client<ApiResponse<PeriodoLetivo>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async marcarVigente(id: string): Promise<PeriodoLetivo> {
    const res = await this.client<ApiResponse<PeriodoLetivo>>(
      `${ROOT}/${encodeURIComponent(id)}/vigente`, { method: 'PATCH' });
    assertApiSuccess(res);
    return res.data;
  }

  async encerrar(id: string): Promise<void> {
    // BE retorna ApiResponse<Void> (envelope com data null) — valida sucesso, ignora data.
    const res = await this.client<ApiResponse<unknown>>(
      `${ROOT}/${encodeURIComponent(id)}/encerrar`, { method: 'PATCH' });
    assertApiSuccess(res);
  }
}
